import React from 'react';
import './workshop-request.css';
import { IWorkshopRequest } from '../../../models/workshop-request';
import Modal, { IModalChildProps } from '../../common/modal';
import { FormattedMessage } from 'react-intl';

interface IWorkshopRequestMessageModal extends IModalChildProps {
    workshopRequest: IWorkshopRequest;
    isNuEar: boolean;
}

export const WorkshopRequestThankYouModal = ({
    workshopRequest,
    onAccept,
    onClose,
    isNuEar,
}: IWorkshopRequestMessageModal) => {
    return (
        <Modal>
            <>
                <div className="well">
                    <div className="row">
                        <div className="col-sm-10">
                            <h1 className={isNuEar ? 'nuEar' : 'starkey'}>
                                <FormattedMessage
                                    id="THANK_YOU_UPPER"
                                    defaultMessage="THANK YOU"
                                />
                                !
                            </h1>
                        </div>
                        <div className="col-sm-2 no-print">
                            <button
                                className="pull-right"
                                onClick={() => window.print()}
                                style={{ paddingTop: '4px' }}
                            >
                                &#128438;&nbsp;Print
                            </button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <p>
                                <FormattedMessage
                                    id="A_Starkey_Workshop_Representative_will"
                                    defaultMessage="A Starkey Workshop Representative will be in
                                touch with you to confirm your preferred dates.
                                If you have any questions, please contact our
                                Workshop Team at 800-328-8602."
                                />
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <h3
                                className={
                                    isNuEar
                                        ? 'gutter-top underline forms nuear'
                                        : 'gutter-top underline forms starkey'
                                }
                            >
                                <FormattedMessage
                                    id="WORKSHOP_REQUEST_UPPER"
                                    defaultMessage="WORKSHOP REQUEST"
                                />
                            </h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-horizontal" role="form">
                            <label
                                className="control-label col-sm-4"
                                style={{
                                    paddingRight: '20px',
                                    textAlign: 'right',
                                }}
                            >
                                <FormattedMessage
                                    id="NAME_UPPER"
                                    defaultMessage="NAME:"
                                />
                            </label>
                            <label
                                className="control-label col-sm-8"
                                style={{
                                    textAlign: 'left',
                                }}
                            >
                                {workshopRequest.contactName}
                            </label>
                            <label
                                className="control-label col-sm-4"
                                style={{
                                    paddingRight: '20px',
                                    textAlign: 'right',
                                }}
                            >
                                ACCOUNT:
                            </label>
                            <label
                                className="control-label col-sm-8"
                                style={{
                                    textAlign: 'left',
                                }}
                            >
                                {workshopRequest.accountNumber}
                            </label>
                            <label
                                className="control-label col-sm-4"
                                style={{
                                    paddingRight: '20px',
                                    textAlign: 'right',
                                }}
                            >
                                PHONE NUMBER:
                            </label>
                            <label
                                className="control-label col-sm-8"
                                style={{
                                    textAlign: 'left',
                                }}
                            >
                                {workshopRequest.phoneNumber}
                            </label>
                            <label
                                className="control-label col-sm-4"
                                style={{
                                    paddingRight: '20px',
                                    textAlign: 'right',
                                }}
                            >
                                EMAIL ADDRESS:
                            </label>
                            <label
                                className="control-label col-sm-8"
                                style={{
                                    textAlign: 'left',
                                }}
                            >
                                {workshopRequest.email}
                            </label>
                            <label
                                className="control-label col-sm-4"
                                style={{
                                    paddingRight: '20px',
                                    textAlign: 'right',
                                }}
                            >
                                WORKSHOP 1:
                            </label>
                            <label
                                className="control-label col-sm-8"
                                style={{
                                    textAlign: 'left',
                                }}
                            >
                                {workshopRequest.workshopDate1!.toLocaleDateString()}
                            </label>
                            {workshopRequest.workshopDate2 && (
                                <div>
                                    <label
                                        className="control-label col-sm-4"
                                        style={{
                                            paddingRight: '20px',
                                            textAlign: 'right',
                                        }}
                                    >
                                        WORKSHOP 2:
                                    </label>
                                    <label
                                        className="control-label col-sm-8"
                                        style={{
                                            textAlign: 'left',
                                        }}
                                    >
                                        {workshopRequest.workshopDate2!.toLocaleDateString()}
                                    </label>
                                </div>
                            )}
                            {workshopRequest.workshopDate3 && (
                                <div>
                                    <label
                                        className="control-label col-sm-4"
                                        style={{
                                            paddingRight: '20px',
                                            textAlign: 'right',
                                        }}
                                    >
                                        WORKSHOP 3:
                                    </label>
                                    <label
                                        className="control-label col-sm-8"
                                        style={{
                                            textAlign: 'left',
                                        }}
                                    >
                                        {workshopRequest.workshopDate3!.toLocaleDateString()}
                                    </label>
                                </div>
                            )}
                            {workshopRequest.workshopDate4 && (
                                <div>
                                    <label
                                        className="control-label col-sm-4"
                                        style={{
                                            paddingRight: '20px',
                                            textAlign: 'right',
                                        }}
                                    >
                                        WORKSHOP 4:
                                    </label>
                                    <label
                                        className="control-label col-sm-8"
                                        style={{
                                            textAlign: 'left',
                                        }}
                                    >
                                        {workshopRequest.workshopDate4!.toLocaleDateString()}
                                    </label>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="modal-footer no-print">
                    <button
                        type="button"
                        className="btn btn-default"
                        onClick={onClose}
                    >
                        Close
                    </button>
                </div>
            </>
        </Modal>
    );
};

export default WorkshopRequestThankYouModal;
